import { AbstractJastVisitor, type CompoundClause, type TerminalClause } from '@atlaskit/jql-ast';

/**
 * Visitor to check if a given terminal clause is child of a compound clause or is the same terminal clause
 */
export class IsInCompoundClauseVisitor extends AbstractJastVisitor<boolean> {
	private terminalClause: TerminalClause;

	constructor(terminalClause: TerminalClause) {
		super();
		this.terminalClause = terminalClause;
	}

	protected defaultResult(): boolean {
		return false;
	}

	visitCompoundClause = (compoundClause: CompoundClause): boolean =>
		compoundClause.clauses.reduce(
			(result, clause) => this.aggregateResult(clause.accept(this), result),
			false,
		);

	visitTerminalClause = (terminalClause: TerminalClause): boolean =>
		terminalClause === this.terminalClause;

	aggregateResult = (aggregate: boolean, nextResult: boolean): boolean => aggregate || nextResult;
}
